import React, { useState, useEffect } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import styles from "./reports.module.css";
import ReportsGraph from "./ReportsGraph";
import { httpSuperAdmin } from "../../Apis/commonApis";
import { useParams, useHistory } from "react-router-dom";
import { formatDate } from "../../utils/CommonFunctions";
const roleAccess = JSON.parse(localStorage.getItem("__csadmin__d"));

const categories = [
  {
    value: 1,
    label: "Revenue",
    [roleAccess?.role?.some(
      (roletype) => roletype?.Modules[8]?.children[0]?.access === "no"
    )
      ? "isDisabled"
      : ""]: true,
  },
  { value: 2, label: "Subscriptions" },
  { value: 3, label: "Clients" },
  {
    value: 4,
    label: "Payments",
    [roleAccess?.role?.some(
      (roletype) => roletype?.Modules[8]?.children[3]?.access === "no"
    )
      ? "isDisabled"
      : ""]: true,
  },
];

const RevenueSubCat = [
  { value: "TotalRevenue", label: "Total Revenue" },
  { value: "CountryWise", label: "Country wise Revenue" },
  { value: "MRR", label: "MRR" },
  { value: "ARPU", label: "ARPU" },
  { value: "MSCR", label: "MSCR" },
  { value: "RevenueByClient", label: "Revenue by  Client" },
  { value: "SalesPerson", label: "Revenue by Sales Person" },
  { value: 0, label: "Revenue by Plan" },
  { value: 1, label: "Revenue by Add-ON" },
  { value: 2, label: "Discount by Coupon" },
];
const SubscriptionSubCat = [
  { value: "newSignUps", label: "Signups" },
  { value: "activations", label: "Activations" },
  { value: "cancellations", label: "Cancellations" },
  { value: "TrialsInProgress", label: "Trials In-Progress" },
  { value: "DeadTrials", label: "Dead Trials" },
  { value: "ChurnRate", label: "Churn Rate" },
  // { value: 7, label: "Churned Subscriptions" },
];
const ClientsSubCat = [
  { value: "clientActiveArray", label: "Active Sites" },
  { value: "clientInactiveArray", label: "In-Active Sites" },
];
const PaymentsSubCat = [
  { value: "paymentFailure", label: "Payment Failure" },
  { value: "DaysToPayment", label: "Days to payment" },
  { value: "Refunds", label: "Refunds" },
];
const planOptions = [
  { value: "base", label: "Base" },
  { value: "advanced", label: "Advanced" },
  { value: "turbo", label: "Turbo" },
];
// 'Clients' (Active Clients, In-Active Clients); 'Payments' (Payment Failure, Days to payment, Refunds)
const Reports = () => {
  const history = useHistory();

  const { dashboardCategory, dashboardSubCategory } = useParams();

  const monthAgoDate = new Date();
  let monthAgo = monthAgoDate.getMonth() - 1;
  monthAgoDate.setMonth(monthAgo);

  const [subCats, setSubCats] = useState();
  const [graphStaticData, setGraphStaticData] = useState({});
  const [dateRange, setDateRange] = useState([monthAgoDate, new Date()]);
  const [startDate, endDate] = dateRange;
  const [selectedCat, setSelectedCat] = useState({ value: 2, label: "Subscriptions" });
  const [selectedSubCat, setSelectedSubCat] = useState({ value: "newSignUps", label: "Signups" });
  const [names, setNames] = useState({
    allCopanyNames: [],
    allCountryNames: [],
    allSalesNames: [],
  });
  const [selectionNames, setSelectionNames] = useState([]);
  const [showNameField, setShowNameField] = useState(false);
  const [nameFieldPlacehold, setNameFieldPlacehold] = useState(false);
  const [selectedNameData, setSelectedNameData] = useState(null);
  const [displayDate, setDisplayDate] = useState({ start: "", end: "" });

  useEffect(() => {
    setSubCats(SubscriptionSubCat);
    let mounted = true;
    if (mounted) {
      setDisplayDate({
                start: startDate.toLocaleDateString(undefined, dateOptions),
                end: endDate.toLocaleDateString(undefined, dateOptions),
              });
              getDashboardDetails(
                formatDate(startDate),
                formatDate(endDate)
              );
      fetchCompanyNames();
    }
    if (dashboardCategory && dashboardSubCategory) {
      setSelectedCat(categories.find(item => item.label === dashboardCategory));
      setSelectedSubCat(categories.find(item => item.label === dashboardSubCategory));
    }

    return () => (mounted = false);
  }, []);

  const getDashboardDetails = async (start, end) => {
    const result = await httpSuperAdmin(
          `getDashboardDetails?startDate=${start}&endDate=${end}`,
          null,
          null
        );
    if (result.status) {
      setGraphStaticData(result.data);
      countryAndSalesPerson(result.data.allCharges);
    }
    // filterGraphs(result.data);
  };

  function countryAndSalesPerson(valueArr) {
    let counries = [];
    let salesPerson = [];
    valueArr?.forEach((elem) => {
      if (elem?.carehomedata?.country) {
        counries.push({ value: elem?.carehomedata?.country, label: elem?.carehomedata?.country });
      }
      if (elem?.carehomedata?.salesPerson) {
        salesPerson.push({ value: elem?.carehomedata?.salesPerson, label: elem?.carehomedata?.salesPerson });
      }
    });
    let uniqueContries = counries.filter(
      (obj, index, self) =>
        index === self.findIndex((o) => o.value === obj.value)
    );
    let uniqueSalesPerson = salesPerson.filter(
      (obj, index, self) =>
        index === self.findIndex((o) => o.value === obj.value)
    );

    // let uniqueContries = [...new Set(counries)];
    // let uniqueSalesPerson = [...new Set(salesPerson)];
    // counries = [];
    // salesPerson = []
    // uniqueContries.forEach(item => {
    //     counries.push({ value: item, label: item });
    // })
    // uniqueSalesPerson.forEach(item => {
    //     salesPerson.push({ value: item, label: item });
    // })
    setNames((prevState) => {
      return {
        ...prevState,
        allCountryNames: uniqueContries,
        allSalesNames: uniqueSalesPerson,
      };
    });
  }

  const fetchCompanyNames = async () => {
    const result = await httpSuperAdmin("getCareHomeAndItsSites", null);
    if (result.status) {

      let companies = [];
      result.data?.forEach((elem) => {
        companies.push({ value: elem.adminId?._id ?? elem.adminId, label: elem.companyName });
      });
      let uniqueData = companies.filter(
        (obj, index, self) =>
          index === self.findIndex((o) => o.value === obj.value)
      );
      setNames((prevState) => {
        return {
          ...prevState,
          allCopanyNames: uniqueData,
        };
      });
    }
  };

  function handleCategoryChange(e) {
    setSelectedCat(e);
    setSelectedSubCat('');
    if (e.value === 1) {
      setSubCats(RevenueSubCat);
    } else if (e.value === 2) {
      setSubCats(SubscriptionSubCat);
    } else if (e.value === 3) {
      setSubCats(ClientsSubCat);
    } else if (e.value === 4) {
      setSubCats(PaymentsSubCat);
    }
    if (dashboardCategory && e.label !== dashboardCategory) {
      history.push("/superadmin/reports");
    }
  }

  function handleSubCatChange(e) {
    setSelectedSubCat(e);
    setSelectedNameData(null);
    if (e.value === "CountryWise") {
      setNameFieldPlacehold("Country");
      setSelectionNames(names.allCountryNames);
      setShowNameField(true);
    } else if (e.value === "RevenueByClient") {
      setNameFieldPlacehold("Company Name");
      setSelectionNames(names.allCopanyNames);
      setShowNameField(true);
    } else if (e.value === "SalesPerson") {
      setNameFieldPlacehold("Sales Person Name");
      setSelectionNames(names.allSalesNames);
      setShowNameField(true);
    } else if (e.value === 0) {
      setNameFieldPlacehold("Plan Type");
      setSelectionNames(planOptions);
      setShowNameField(true);
    } else {
      setShowNameField(false);
    }
    if (dashboardSubCategory && e.value !== dashboardSubCategory) {
      history.push("/superadmin/reports");
    }
  }

  function handleNameSelect(e) {
    setSelectedNameData(e);
  }

  function customDateChangeHandler(update) {
    setDateRange(update);
  }

  const dateOptions = { day: "numeric", month: "long", year: "numeric" };

  return (
    <div className="page-wrapper">
      <div className="card">
        <div className="card-body">
          {/* <h4 className="card-title">Reports</h4> */}
          <div className={`btns_head wellbeign_list ${styles.divMargin}`}>
            <div className="row align-item-center">
              <div className="col-md-3">
                <div className="dropdown category_dropdown mb-3 category_dropdown_1">
                  <Select
                    className={styles.dropdowns}
                    value={selectedCat}
                    options={categories}
                    placeholder="Select Category"
                    onChange={handleCategoryChange}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="dropdown category_dropdown mb-3 category_dropdown_1">
                  <Select
                    className={styles.dropdowns}
                    value={selectedSubCat}
                    placeholder="Select Sub-Category"
                    options={subCats}
                    onChange={handleSubCatChange}
                  />
                </div>
              </div>
              {
                <div className="col-md-4">
                  {/* <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} /> */}
                  <DatePicker
                    className={styles.datePicker}
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    maxDate={new Date()}
                    onChange={(update) => {
                      customDateChangeHandler(update);
                    }}
                    isClearable={true}
                  />
                </div>
              }
              <div className="col-md-2">
                {/* <button
                  className={` ${styles.btncolor} mb-4 btn btn-sm float-end`}
                  style={{ backgroundColor: "#BB6BD9 !important" }}
                >
                  Download
                </button> */}
                <button
                  className=" mb-4 btn btn-sm float-end"
                  onClick={() => window.print()}
                >
                  Print
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-8">
                {/* isMulti */}
                {showNameField && (
                  <Select
                    className={`basic-multi-select ${styles.nameDropdown}`}
                    // classNamePrefix="select"
                    placeholder={`Please Select ${nameFieldPlacehold}`}
                    value={selectedNameData}
                    options={selectionNames}
                    onChange={handleNameSelect}
                  />
                )}
              </div>
            </div>
            <ReportsGraph
              dateRange={dateRange}
              graphStaticData={graphStaticData}
              selectedCat={selectedCat.label}
              selectedSubCat={selectedSubCat?.value}
              selectedLabel={selectedSubCat?.label}
              selectedNameData={selectedNameData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;
